import LinkButton, {
  Button as LinkButtonContainer,
} from "@components/buttons/LinkButton"
import breakpoints from "@constants/breakpoints"
import colors from "@constants/colors"
import { body16MainStyles, h4Styles, h5Styles } from "@constants/typography"
import React from "react"
import styled, { css } from "styled-components"

import RecentItem, { RecentItemProps } from "./RecentItem"

const Container = styled.div`
  overflow: hidden;
  overflow-y: auto;
  height: 100%;
  padding: 84px 20px 42px;

  ${LinkButtonContainer} {
    justify-content: center;
    width: auto;
    padding: 0 42px;

    span {
      padding: 0;
    }
  }

  @media ${breakpoints.tablet} {
    padding: 84px 32px 42px;
  }

  @media ${breakpoints.laptop} {
    padding: 160px calc((100% - 820px) / 2) 80px;
  }
`

const Content = styled.div`
  @media ${breakpoints.tablet} {
    text-align: center;

    a {
      display: inline-block;
    }
  }

  @media ${breakpoints.laptop} {
    text-align: center;

    a {
      display: inline-block;
    }
  }
`

const Header = styled.h4`
  ${h4Styles}

  @media ${breakpoints.laptop} {
    ${h5Styles}
  }
`

const Text = styled.div`
  ${body16MainStyles}
  color: ${colors.mediumGray};

  @media ${breakpoints.tablet} {
    text-align: center;
  }

  @media ${breakpoints.laptop} {
    text-align: center;
  }
`

const Items = styled.div<{ single: boolean }>`
  ${({ single }) => css`
    @media ${breakpoints.tablet} {
      flex-wrap: wrap;
      justify-content: ${single ? "center" : "space-between"};
      display: flex;
    }

    @media ${breakpoints.laptop} {
      flex-wrap: wrap;
      justify-content: ${single ? "center" : "space-between"};
      display: flex;
    }
  `}
`

const VerticalSpace = styled.div<{ height?: string; laptopHeight?: string }>`
  ${({ height, laptopHeight }) => css`
    height: ${height || "20px"};

    @media ${breakpoints.laptop} {
      height: ${laptopHeight || height || "20px"};
    }
  `}
`

interface EmptyCartProps {
  recentItems: Array<RecentItemProps>
}

const EmptyCart: React.FC<EmptyCartProps> = ({ recentItems }) => {
  return (
    <Container>
      <Content>
        <Header>Your cart's empty</Header>
        <VerticalSpace height="58px" laptopHeight="8px" />
        <Text>Have an account? Sign in to see your cart.</Text>
        <VerticalSpace laptopHeight="36px" />
        <LinkButton external noDash text="Sign In" to="/login" />
        <VerticalSpace height="170px" laptopHeight="220px" />
      </Content>
      {recentItems.length > 0 && (
        <>
          <Text>Recently Viewed</Text>
          <VerticalSpace height="24px" laptopHeight="28px" />
          <Items single={recentItems.length === 1}>
            {recentItems.map((item, i) => (
              <RecentItem key={i} {...item} />
            ))}
          </Items>
        </>
      )}
    </Container>
  )
}
export default EmptyCart
